import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { FooterComponent } from './components/footer/footer.component';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ConsultasComponent } from './pages/consultas/consultas.component';
import { CommonModule } from '@angular/common';
import { DetalleExpedienteComponent } from './pages/detalle-expediente/detalle-expediente.component';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ArchivosExpedieteComponent } from './pages/archivos-expediete/archivos-expediete.component';
import { PromociondetalleComponent } from './pages/promociondetalle/promociondetalle.component';
import { NgxUiLoaderConfig, NgxUiLoaderModule } from 'ngx-ui-loader';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: "#5e4edb",
  fgsColor: "#5e4edb",
  overlayColor: "rgba(40, 40, 40, 0.8)",
  pbColor: "#5e4edb",
  textColor: "#FFF",
};

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent,
    ConsultasComponent,
    DetalleExpedienteComponent,
    ArchivosExpedieteComponent,
    PromociondetalleComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig)
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
